import React, { Fragment } from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"

const DispatchForm = props => {
  return (
    <div class="col-md-12 mx-auto br-col p-1">
      <div className="col-md-12 d-flex flex-row justify-content-around">
        <div className="col-sm-4">
          <label className="text-center">Dispatched Between</label>
          <div className="col-md-6" style={{ zIndex: "1000" }}>
            <label className="text-center">From</label>
            <Field
              inputType="date"
              inputName="fromDate"
              label="from Date"
              value={props.fromDate}
              onChange={props.updateState}
              disabled={false}
              className="Select-control w-100"
            />
          </div>
          <div className="col-md-6" style={{ zIndex: "1000" }}>
            <label className="text-center">To</label>
            <Field
              inputType="date"
              inputName="toDate"
              label="to Date"
              value={props.toDate}
              onChange={props.updateState}
              disabled={false}
              className="Select-control w-100"
            />
          </div>
        </div>
        <div className="col-md-4" style={{ zIndex: 1000 }}>
          <span className="p-3"></span>
          <label className="text-center">Customer department</label>
          <App
            customerInfo={props.customerWithDepartment}
            selectedCustomers={props.storeCustomerData}
          />
        </div>
        <div className="col-md-2">
          <span className="p-3"></span>
          <label className="text-center">Source of request</label>
          <Field
            inputType="select"
            inputName="typeOfRequest"
            value={props.typeOfRequest}
            options={props.typeOfRequestOptions}
            onChange={props.updateState}
            disabled={false}
            className="Select-control w-100"
          />
        </div>
        <div className="col-md-2">
          <span className="p-3"></span>
          <label className="text-center">Sample Type</label>
          {/* <Field
            inputType="select"
            inputName="sampleType"
            value={props.sampleType}
            options={props.sampleTypeOptions}
            onChange={props.updateState}
            disabled={false}
            className="Select-control w-100"
          /> */}
          <Picky
          value={props.arrayValue2}
          options={props.sampleTypeOptions}
          onChange={props.selectMultipleOption2}
          open={false}
          valueKey="value"
          labelKey="label"
          multiple={true}
          includeSelectAll={true}
          manySelectedPlaceholder={"%s selected"} 
          allSelectedPlaceholder={"%s selected"}
          includeFilter={true} 
          dropdownHeight={300}
          placeholder="Select a sample type" 
          disabled={false}
      />
                        
        </div>
      </div>
      <div className="col-md-12 d-flex flex-row justify-content-around">
        <div className="col-md-2">
          <label className="text-center">Location</label>
          <Field
            inputType="select"
            inputName="location"
            value={props.location}
            options={props.LOCATION}
            onChange={props.updateState}
            disabled={false}
            className="w-100"
          />
        </div>

        <div className="col-md-2">
          <label className="text-center">Courier</label>
          <Field
            inputType="select"
            inputName="courier"
            value={props.courier}
            options={props.courierOptions}
            onChange={props.updateState}
            disabled={false}
            className="w-100"
          />
        </div>

        <div className="col-md-2">
          <label className="text-center">AWB Number</label>
          <Field
            inputType="text"
            inputName="awbNumber"
            value={props.awbNumber}
            onChange={props.updateState}
            disabled={false}
            className="w-100"
          />
        </div>
      </div>
    </div>
  );
};

export default DispatchForm;



// WEBPACK FOOTER //
// ./src/components/Report/forms/DispatchForm.js